import React from 'react';
import styles from './styles.module.css'
const SuccessPage = () => {
  return (
    <div className={`${styles.body} flex-1 col-9`}>
      <div className={styles.card} style={{ minHeight: '100%' }}>
        <div style={{
          borderRadius: 200, height: 200, width: 200, background: '#F8FAF5', margin: '0 auto'
        }}>
          <i className={`checkmark ${styles.i}`}>✓</i>
        </div>
        <h1 className={styles.h1}>Success</h1>
        <p className={styles.p}>You have completed all the questions.<br /> Please wait for a response from the organizers.</p>
      </div>
    </div >
  );
}

export default SuccessPage;
